export function PageHeader({ eyebrow, title, description, actions }) {
    return (
        <div className="mb-10 flex items-end justify-between gap-8 pb-6 border-b border-cream-200">
            <div className="min-w-0">
                {eyebrow && (
                    <div className="inline-flex items-center gap-2 mb-4">
                        <span className="size-1.5 rounded-full bg-accent-500" />
                        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-500">
                            {eyebrow}
                        </span>
                    </div>
                )}
                <h1 className="heading-display text-[32px] font-semibold text-ink-900 leading-[1.1] tracking-tight">
                    {title}
                </h1>
                {description && (
                    <p className="text-sm text-ink-500 mt-3 max-w-2xl leading-relaxed">
                        {description}
                    </p>
                )}
            </div>
            {actions && <div className="flex items-center gap-2 shrink-0 pb-2">{actions}</div>}
        </div>
    );
}

export function SectionHeader({ title, description, children }) {
    return (
        <div className="flex items-end justify-between mb-4">
            <div>
                <h2 className="heading-display text-lg font-semibold text-ink-900">
                    {title}
                </h2>
                {description && (
                    <p className="text-xs text-ink-400 mt-0.5">{description}</p>
                )}
            </div>
            {children && <div>{children}</div>}
        </div>
    );
}
